import React from "react";
import { Link } from "react-router-dom";
import { useCompare } from "../../context/CompareContext";
import { GitCompare, X } from "lucide-react";

export default function CompareBar() {
  const { compareList, removeFromCompare, clearCompare } = useCompare();
  if (compareList.length === 0) return null;

  return (
    <div style={{ position: "fixed", bottom: 0, left: 0, right: 0, background: "#fff", borderTop: "1px solid var(--border)", padding: "12px 24px", display: "flex", alignItems: "center", gap: 16, zIndex: 450, boxShadow: "0 -4px 16px rgba(0,0,0,0.08)", flexWrap: "wrap" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8, flex: 1, flexWrap: "wrap" }}>
        <GitCompare size={18} color="var(--brand)" />
        <span style={{ fontWeight: 600, fontSize: 14 }}>Comparing {compareList.length} product{compareList.length !== 1 ? "s" : ""}:</span>
        {compareList.map(p => (
          <div key={p.id} style={{ display: "flex", alignItems: "center", gap: 6, padding: "4px 10px", background: "var(--surface)", border: "1px solid var(--border)", borderRadius: 100, fontSize: 13 }}>
            {p.name.slice(0, 24)}{p.name.length > 24 ? "…" : ""}
            <button onClick={() => removeFromCompare(p.id)} style={{ border: "none", background: "transparent", cursor: "pointer", display: "flex", color: "var(--text-muted)" }}><X size={12} /></button>
          </div>
        ))}
      </div>
      <div style={{ display: "flex", gap: 10 }}>
        <Link to="/compare" className="btn btn-primary btn-sm"><GitCompare size={14} /> Compare Now</Link>
        <button onClick={clearCompare} className="btn btn-secondary btn-sm">Clear</button>
      </div>
    </div>
  );
}
